import type { GameStats } from '../types/game'
import type { StatsResult } from '../services/account/statsApi'

/** The shape the existing stats screens draw, filled from the server's numbers. */
export const toGameStats = (result: StatsResult | null): GameStats => {
  if (!result) {
    return { gamesPlayed: 0, gamesWon: 0, currentStreak: 0, maxStreak: 0, guessDistribution: {} }
  }

  const guessDistribution: Record<number, number> = {}
  for (const [guesses, count] of Object.entries(result.stats.wordle.guessDistribution)) {
    const key = Number(guesses)
    if (Number.isInteger(key) && key > 0 && typeof count === 'number') guessDistribution[key] = count
  }

  return {
    gamesPlayed: result.stats.played,
    gamesWon: result.stats.won,
    // The daily streak: any game finished on a day keeps it (see the backend's streak rules).
    currentStreak: result.streak.current,
    maxStreak: result.streak.longest,
    guessDistribution,
  }
}
